import { set, addDays } from 'date-fns';

export const appVersion = `PowerSIMM V - v${process.env.REACT_APP_VERSION}-${process.env.REACT_APP_BUILD_ID}`;

export const convertRelativeToDate = (value) => {
    return addDays(set(new Date(), { seconds: 0, milliseconds: 0 }), value);
};
